import { MapViewMarker } from "@msuite/ui/map";
import type { ClassNameProps } from "@msuite/ui/types";

export function VehicleMapPin({ className }: ClassNameProps) {
	/** Render */
	return (
		<MapViewMarker
			iconName="Truck"
			color="var(--color-accent-500)"
			className={className}
		/>
	);
}
